import { render } from "./nuevoPedido.vue?vue&type=template&id=4279945c&scoped=true"
import script from "./nuevoPedido.vue?vue&type=script&lang=js"
export * from "./nuevoPedido.vue?vue&type=script&lang=js"

import "./nuevoPedido.vue?vue&type=style&index=0&id=4279945c&scoped=true&lang=css"
import "./nuevoPedido.vue?vue&type=style&index=1&id=4279945c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4279945c"]])

export default __exports__